module.exports = __webpack_public_path__ + "static/media/sharks-silhouette.1ad5fa8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/sharks-silhouette.svg
// module id = 1335
// module chunks = 0